import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, position: PropTypes.oneOf(['left', 'right', 'center']) };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    position: 'left',
};

class ButtonContainer extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            position,
        } = this.props;
        return [
            'c-grid__row c-grid__row--no-col',
            position === 'right' ? 'c-grid__row--align-right' : false,
            position === 'center' ? 'c-grid__row--align-hcenter' : false,
            className,
        ];
    }

}

ButtonContainer.propTypes = propTypes;

ButtonContainer.defaultProps = defaultProps;

export default ButtonContainer;
